import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAIL = 'FETCH_ROLES_FAIL';
export const FETCH_ROLE = 'FETCH_ROLE';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAIL = 'FETCH_ROLE_FAIL';
export const CLEAR_ROLES = 'CLEAR_ROLES';
export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = 'UPDATE_ROLE_FAIL';
export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL';
export const ADD_ROLE_RESOURCE = 'ADD_ROLE_RESOURCE';
export const ADD_ROLE_RESOURCE_SUCCESS = 'ADD_ROLE_RESOURCE_SUCCESS';
export const ADD_ROLE_RESOURCE_FAIL = 'ADD_ROLE_RESOURCE_FAIL';
export const REMOVE_ROLE_RESOURCE = 'REMOVE_ROLE_RESOURCE';
export const REMOVE_ROLE_RESOURCE_SUCCESS = 'REMOVE_ROLE_RESOURCE_SUCCESS';
export const REMOVE_ROLE_RESOURCE_FAIL = 'REMOVE_ROLE_RESOURCE_FAIL';

// Reducer
export default function rolesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_ROLES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ROLES_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_ROLES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_ROLES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case FETCH_ROLE:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ROLE_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_ROLE_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CREATE_ROLE_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case UPDATE_ROLE_SUCCESS:
    case ADD_ROLE_RESOURCE_SUCCESS:
    case REMOVE_ROLE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_ROLE_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchRoles(payload) {
  return { type: FETCH_ROLES, payload };
}

export function fetchRolesSuccess(payload) {
  return { type: FETCH_ROLES_SUCCESS, payload };
}

export function fetchRolesFail(payload) {
  return { type: FETCH_ROLES_FAIL, payload };
}

export function fetchRole(payload) {
  return { type: FETCH_ROLE, payload };
}

export function fetchRoleSuccess(payload) {
  return { type: FETCH_ROLE_SUCCESS, payload };
}

export function fetchRoleFail(payload) {
  return { type: FETCH_ROLE_FAIL, payload };
}

export function clearRoles(payload) {
  return { type: CLEAR_ROLES, payload };
}

export function createRole(payload) {
  return { type: CREATE_ROLE, payload };
}

export function createRoleSuccess(payload) {
  return { type: CREATE_ROLE_SUCCESS, payload };
}

export function createRoleFail(payload) {
  return { type: CREATE_ROLE_FAIL, payload };
}

export function updateRole(payload) {
  return { type: UPDATE_ROLE, payload };
}

export function updateRoleSuccess(payload) {
  return { type: UPDATE_ROLE_SUCCESS, payload };
}

export function updateRoleFail(payload) {
  return { type: UPDATE_ROLE_FAIL, payload };
}

export function deleteRole(payload) {
  return { type: DELETE_ROLE, payload };
}

export function deleteRoleSuccess(payload) {
  return { type: DELETE_ROLE_SUCCESS, payload };
}

export function deleteRoleFail(payload) {
  return { type: DELETE_ROLE_FAIL, payload };
}

export function addRoleResource(payload) {
  return { type: ADD_ROLE_RESOURCE, payload };
}

export function addRoleResourceSuccess(payload) {
  return { type: ADD_ROLE_RESOURCE_SUCCESS, payload };
}

export function addRoleResourceFail(payload) {
  return { type: ADD_ROLE_RESOURCE_FAIL, payload };
}

export function removeRoleResource(payload) {
  return { type: REMOVE_ROLE_RESOURCE, payload };
}

export function removeRoleResourceSuccess(payload) {
  return { type: REMOVE_ROLE_RESOURCE_SUCCESS, payload };
}

export function removeRoleResourceFail(payload) {
  return { type: REMOVE_ROLE_RESOURCE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchRoles({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('settings/role/search/', 'POST', {
    filters: [
      {
        name: 'Name',
        operation: 'ne',
        val: 'System',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestSearchRoles({ limit, offset, filters = [], sortBy = [] }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('settings/role/search/', 'POST', {
    filters: [
      ...filters,
      {
        name: 'Name',
        operation: 'ne',
        val: 'System',
      },
    ],
    sort_by: [
      ...sortBy,
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    ...limit ? { limit } : {},
    ...offset ? { offset } : {},
  });
  abort = request.abort;
  return request.res;
}

export function requestFetchRole(payload) {
  return callApi(`settings/role/?id=${payload}`);
}

export function requestCreateRole(payload) {
  return callApi('settings/role/', 'POST', payload);
}

export function requestUpdateRole(payload) {
  return callApi('settings/role/', 'PATCH', payload);
}

export function requestDeleteRole(payload) {
  return callApi(`settings/role/?id=${payload}`, 'DELETE');
}

export function requestAddRoleResource(payload) {
  return callApi('settings/role/change_resource/add/', 'POST', payload);
}

export function requestRemoveRoleResource(payload) {
  return callApi('settings/role/change_resource/remove/', 'POST', payload);
}

// Sagas
function* fetchRolesSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchRoles, action.payload)
      : yield call(requestFetchRoles, action.payload);
    yield put(fetchRolesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchRolesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchRoleSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchRole, action.payload.ID);
    if (res.data.ID) {
      yield put(fetchRoleSuccess({
        ...res.data,
        triggerLoading,
      }));
    } else {
      yield put(fetchRoleFail({
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchRoleFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createRoleSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateRole, values);
    yield put(createRoleSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New Role successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createRoleFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateRoleSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateRole, values);
    yield put(updateRoleSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Role successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateRoleFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteRoleSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeleteRole, ID);
    yield put(deleteRoleSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Role successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deleteRoleFail(err.data));
    yield put(addNotification({
      message: 'Failed to delete Role',
      variant: 'warning',
    }));
  }
}

function* addRoleResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestAddRoleResource, values);
    yield put(addRoleResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addRoleResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removeRoleResourceSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestRemoveRoleResource, values);
    yield put(removeRoleResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removeRoleResourceFail(err.data));
    if (reject) {
      reject(err);
    }
  }
}

export function* rolesSaga() {
  yield takeLatest(FETCH_ROLES, fetchRolesSaga);
  yield takeLatest(FETCH_ROLE, fetchRoleSaga);
  yield takeEvery(CREATE_ROLE, createRoleSaga);
  yield takeEvery(UPDATE_ROLE, updateRoleSaga);
  yield takeEvery(DELETE_ROLE, deleteRoleSaga);
  yield takeEvery(ADD_ROLE_RESOURCE, addRoleResourceSaga);
  yield takeEvery(REMOVE_ROLE_RESOURCE, removeRoleResourceSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/roles.js